import React from 'react';
import { CHECKOUT_URL, PRODUCT_NAME, problemQuestions } from '../data/atlante';
export function ProblemSection() {
  return <section className="border-y-4 border-gold/40 bg-white px-4 py-5 sm:py-7" data-id="element-139" data-mp="2ltmgzr0xdnkj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="30hhavaqo5xz7">
        <h2 className="text-xl leading-tight text-navy sm:text-2xl" data-id="element-141" data-mp="30j0v1cfg4t69">
          E SE LE TUE RISORSE DI PROTESI DENTALE FOSSERO GIÀ ORGANIZZATE?
        </h2>

        <p className="mt-2 text-[13px] font-semibold leading-snug text-navy sm:text-[15px]" data-id="element-142" data-mp="39gkx2nl4uthx">
          Conosci già la professione.
        </p>
        <p className="mt-1 text-[13px] font-medium leading-snug text-slate2 sm:text-[15px]" data-id="element-143" data-mp="35in55czz9tau">
          Il problema è dover continuamente trovare il riferimento giusto,
          confrontare preparazioni e consultare diverse risorse per analizzare il
          prossimo caso.
        </p>

        <ul className="mx-auto mt-3 grid max-w-2xl gap-1.5 text-left sm:grid-cols-2" data-id="element-144" data-mp="1p4568xn35bbz">
          {problemQuestions.map(question => <li key={question} className="border-l-4 border-gold bg-ivory px-3 py-1.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-145" data-mp="jdn5i4pl305g">
              {question}
            </li>)}
        </ul>

        <p className="mt-3 text-[13px] font-medium leading-snug text-slate2 sm:text-[15px]" data-id="element-146" data-mp="sc8hti4gpixs">
          Invece di cercare tra risorse sparse,{' '}
          <a href={CHECKOUT_URL} className="font-extrabold text-navy underline decoration-gold decoration-2 underline-offset-2" data-id="element-147" data-mp="123v2e52owud7">
            {PRODUCT_NAME}
          </a>{' '}
          ti offre una biblioteca organizzata di risorse visuali e pronte da
          consultare in 6 aree essenziali della protesi dentale.
        </p>

        <p className="mt-2 font-display text-sm font-extrabold uppercase tracking-wide text-green sm:text-base" data-id="element-148" data-mp="1g19y1rjjdydm">
          Osserva. Confronta. Analizza. Consulta.
        </p>
      </div>
    </section>;
}